import createImageUrlBuilder from "@sanity/image-url";
import { dataset, projectId } from "./env";

// https://www.sanity.io/docs/image-url
var builder = createImageUrlBuilder({
  projectId: projectId,
  dataset: dataset
});
export var urlForImage = function urlForImage(source) {
  return builder.image(source).auto("format").fit("max");
};